import o from"react";import e from"prop-types";import n from"styled-components";import{calculateRem as r}from"@vds-core/utilities";import{Fonts as t}from"@vds-core/typography";import{TypographyTokens as i}from"@vds-tokens/typography";import{AccessibilityTokens as s}from"@vds-tokens/accessibility";const a=r(26),d={disabled:e.bool},l=n.label.withConfig({displayName:"CheckboxLabelWrapper",componentId:"VDS__sc-uxjioj-0"})`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  line-height: ${i.lineheight.body[20].value};
  font-size: ${i.fontsize.body[16].value};
  font-family: ${t.VerizonNHGeDS};
  letter-spacing: ${function({letterSpacing:o}){return o||i.letterspacing.wide.value}};
  ${function({errored:o}){return o&&"\n  margin-bottom: 9px; //8px + 1px additonal border outside aligned\n  "}};
  ${function({disabled:o}){return o&&"\n    cursor: default;\n  "}};

  color: ${function({color:o}){return o}};

  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    overflow: hidden;
    padding: 0;
    border: 0;
    white-space: nowrap;
    z-index: 1;
    &:hover {
      cursor: pointer;
    }
    ${function({showFocus:o,color:e,focusBorderRadius:n}){return o&&`\n      &:focus {\n        outline: none;\n        + svg {\n          outline: none;\n        } \n        &:not(:hover):not(:visited):not(:active) + span {\n          &::after {\n            background: transparent;\n            border: ${r(s.focusring.borderwidth.value)} ${s.focusring.borderstyle.value} ${e};\n            box-sizing: border-box;\n            content: '';\n            height: ${a};\n            left: 50%;\n            position: absolute;\n            top: 50%;\n            transform: translate(-50%, -50%);\n            width: ${a};\n            border-radius: ${n};\n          }\n        }\n      }\n      `}};
  }
`,p=function(e){return o.createElement(l,Object.assign({},e,{disabled:e.disabled,color:e.color}))};p.propTypes=d,p.defaultProps={disabled:!1};export{p as default};
